const AgeGateConstants = {
  logo_tagline:     'Discover Cannabis',
  form_instruction: 'Please tell us you\'re over 21',
}

export default AgeGateConstants;